import * as z from 'zod'

// The four IRS filing statuses. Determines standard-deduction rows, bracket
// tables, and thresholds throughout the tax engine.
export enum FilingStatus {
  SINGLE = 'Single Taxpayers',
  MARRIED_FILING_JOINTLY = 'Married Filing Jointly',
  MARRIED_FILING_SEPARATELY = 'Married Filing Separately',
  HEAD_OF_HOUSEHOLD = 'Head of Household',
}

export const filingStatusSchema = z.enum(FilingStatus)
